export default __webpack_public_path__ + "static/media/IncredibleAnimalsCamouflage_02.f06539cf.png";